import { Box, Typography } from "@material-ui/core";
import {
  BannerSeverity,
  Icon,
  IconName,
  NotificationBanner,
  useDeviceTypes,
} from "halifax";
import clsx from "clsx";
import React from "react";
import { PriceChangeInlineMessageConnectorProps } from "./container";
import { PRICE_DECREASE_INLINE_MESSAGE } from "./textConstants";
import "./styles.scss";

export type IPriceChangeInlineMessageProps =
  PriceChangeInlineMessageConnectorProps;

// CT1261T-421: non-blocking inline notice for a price decrease (replaces the
// legacy modal). Dismissible — acknowledging the price difference clears it
// (and it re-arms on the next quote). Also clears on its own when the diff
// resolves.
export const PriceChangeInlineMessage = ({
  showPriceDecreaseMessage,
  amount,
  acknowledgePriceDifference,
}: IPriceChangeInlineMessageProps) => {
  const { matchesMobile } = useDeviceTypes();

  if (!showPriceDecreaseMessage || amount == null) return null;

  return (
    <NotificationBanner
      className={clsx("price-change-inline-message", {
        mobile: matchesMobile,
      })}
      // INFO renders unstyled in halifax; NOTICE has a style.
      severity={BannerSeverity.NOTICE}
      icon={<Icon name={IconName.InfoCircleFill} />}
      content={
        <Box className="price-change-inline-message-content">
          <Typography variant="body2">
            {PRICE_DECREASE_INLINE_MESSAGE(amount)}
          </Typography>
        </Box>
      }
      onDismiss={acknowledgePriceDifference}
    />
  );
};
